export default function Functionality({ register, errors }) {
  const fieldName = "functionality";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Specific technical features or requirements
      </label>
      <span className="wdc-field-hint">If nothing, you may just enter 'no'</span>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="3"
        placeholder="e.g. online bookings, member login, payment gateway…"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
